'use client';

import React from 'react';

import { Box, Divider, VStack } from '@chakra-ui/react';

import { CustomText } from '@components/Custom-text';

import Expertise from './Expertise';
import YearsOfExperienceSlider from '../general/YearsOfExperienceSlider';

const ExperienceFilter = () => (
    <VStack width="100%" align="flex-start" sx={{ mb: '100px' }}>
        <CustomText color="mainText" weight={500} size="md">
            Experience
        </CustomText>
        <Expertise />
        <Divider />
        <Box sx={{ marginBottom: '30px', width: '100%' }}>
            <CustomText marginTop={4} color="mainText" weight={500} size="md">
                Years of experience
            </CustomText>
            <YearsOfExperienceSlider />
        </Box>
        <Divider />
    </VStack>
);

export default ExperienceFilter;
